import { Application } from './app';
import { Bundle } from './bundle';

export class MessageReport {
  id: number;
  sender: string;
  recipient: string;
  schedule: Date;
  rate: number;
  message: string;
  status: boolean;
  status_message: string;
  reason: string;
  created_at: Date;
  updated_at: Date;

  constructor() {
    this.id = 0;
    this.sender = '';
    this.recipient = '';
    this.schedule = null;
    this.rate = 0;
    this.message = '';
    this.status = false;
    this.status_message = '';
    this.sender = '';
    this.reason = '';
    this.created_at = null;
    this.updated_at = null;
  }
}

export class SentCampaignReport {
  sender: string;
  message: string;
  pending: number;
  recipients: number;
  sent: number;
  campaign: string;
  rate: number;
  created_at: Date;

  constructor() {
    this.sender = '';
    this.message = '';
    this.pending = 0;
    this.recipients = 0;
    this.sent = 0;
    this.campaign = '';
    this.rate = 0;
    this.created_at = null;
  }
}

export class TopupReport {
  id: number;
  bundle: Bundle;
  successful: boolean;
  created_at: Date;
  updated_at: Date;

  constructor() {
    this.id = 0;
    this.bundle = new Bundle();
    this.successful = false;
    this.created_at = null;
    this.updated_at = null;
  }
}
export class AppTopupReport {
  id: number;
  user_id: number;
  app: Application;
  refund_id: number;
  is_refund: boolean;
  refunded: boolean;
  credits: number;
  amount: number;
  created_at: Date;
  updated_at: Date;

  constructor() {
    this.id = 0;
    this.user_id = 0;
    this.app = null;
    this.is_refund = false;
    this.refund_id = 0;
    this.credits = 0;
    this.amount = 0;
    this.refunded = false;
    this.created_at = null;
    this.updated_at = null;
  }
}

export class FileDownload {
  url: string;
  name?: string;

  constructor() {
    this.url = '';
    this.name = '';
  }
}

export class CampaignReport {
  total: number;
  unsent_pending: number;
  unsent_scheduled: number;
  sent_success: number;
  sent_failure: number;
  sender: string;
  date: Date;
  scheduled_date: Date;
  sample: string;

  constructor() {
    this.total = 0;
    this.unsent_pending = 0;
    this.unsent_scheduled = 0;
    this.sent_success = 0;
    this.sent_failure = 0;
    this.sender = '';
    this.date = null;
    this.scheduled_date = null;
    this.sample = '';
  }
}
